// import React, { useState } from 'react';

// const ContactUs = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     organization: '',
//     message: ''
//   });

//   // Construct email dynamically for protection
//   const emailUser = 'info';
//   const emailDomain = 'yrcgi.com';
//   const email = `${emailUser}@${emailDomain}`;

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Logic for form submission would go here
//     console.log("Form Submitted:", formData);
//     alert("Thank you. Your inquiry has been sent to our engineering team.");
//   };

//   return (
//     <div style={pageContainer}>
//       <div style={contentWrapper}>
        
//         {/* LEFT SIDE: Direct Contact & Info */}
//         <div style={infoSide}>
//           <span style={eyebrow}>Connect with Us</span>
//           <h1 style={titleStyle}>Request a Review</h1>
//           <p style={descriptionStyle}>
//             Describe your existing software boundaries or data modeling requirements. 
//             Our team will review your parameters and arrange a technical consultation.
//           </p>

//           <div style={contactMethod}>
//             <div style={iconCircle}>✉️</div>
//             <div>
//               <div style={methodLabel}>Email for Inquiries</div>
//               <a href={`mailto:${email}`} style={emailLink}>
//                 {email}
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* RIGHT SIDE: The Professional Form */}
//         <div style={formSide}>
//           <form onSubmit={handleSubmit} style={formStyle}>
//             <div style={inputGroup}>
//               <label style={labelStyle}>Full Name*</label>
//               <input 
//                 type="text" 
//                 name="name" 
//                 required 
//                 style={inputStyle} 
//                 placeholder="Jane Doe"
//                 onChange={handleChange}
//               />
//             </div>

//             <div style={inputGroup}>
//               <label style={labelStyle}>Institutional Email*</label>
//               <input 
//                 type="email" 
//                 name="email" 
//                 required 
//                 style={inputStyle} 
//                 placeholder="name@organization.com"
//                 onChange={handleChange}
//               />
//             </div>

//             <div style={inputGroup}>
//               <label style={labelStyle}>Organization / Research Board</label>
//               <input 
//                 type="text" 
//                 name="organization" 
//                 style={inputStyle} 
//                 placeholder="University or Company Name"
//                 onChange={handleChange}
//               />
//             </div>

//             <div style={inputGroup}>
//               <label style={labelStyle}>Project Insight*</label>
//               <textarea 
//                 name="message" 
//                 required 
//                 style={{...inputStyle, minHeight: '120px', resize: 'vertical'}} 
//                 placeholder="Briefly describe your data or software challenge..."
//                 onChange={handleChange}
//               />
//             </div>

//             <button type="submit" style={submitButtonStyle}>
//               Send Inquiry →
//             </button>
//           </form>
//         </div>

//       </div>
//     </div>
//   );
// };

import React from 'react';

const ContactUs = () => {
  
  // This function assembles the email ONLY when a human clicks.
  // Bots cannot read this logic.
  const handleSecureContact = (e) => {
    e.preventDefault();
    const u = "info";
    const d = "yrcgi.com";
    const subject = encodeURIComponent("Architectural Review Inquiry");
    
    // This opens the user's email app instantly
    window.location.href = `mailto:${u}@${d}?subject=${subject}`;
  };

  return (
    <div style={pageContainer}>
      <div style={contentWrapper}>
        
        {/* LEFT SIDE: Identity & Trust */}
        <div style={infoSide}>
          <span style={eyebrow}>Connect with Us</span>
          <h1 style={titleStyle}>Request a Review</h1>
          <p style={descriptionStyle}>
            Our architects provide technical oversight and relational data modeling 
            for institutional research boards and enterprise operations.
          </p>

          <div style={contactMethod}>
            <div style={iconCircle}>📍</div>
            <div>
              <div style={methodLabel}>Operations</div>
              <div style={addressText}>Yellow Ray Consulting Group Inc.<br/>Canada</div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: The Secure Action */}
        <div style={formSide}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ fontSize: '50px', marginBottom: '20px' }}>✉️</div>
            <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', marginBottom: '15px' }}>
              Direct Inquiry Portal
            </h3>
            <p style={{ color: '#64748b', fontSize: '16px', lineHeight: '1.6', marginBottom: '30px' }}>
              Connect with our team to discuss your architectural 
              requirements and project parameters.
            </p>
            
            <button 
              onClick={handleSecureContact} 
              style={submitButtonStyle}
            >
              Initialize Direct Inquiry →
            </button>

            <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '25px', fontStyle: 'italic' }}>
              * Please include your organization name and project details in your message. 
              Response time is typically within 24 business hours.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

// ================= STYLES =================

const pageContainer = {
  backgroundColor: '#f8fafc',
  minHeight: '80vh',
  padding: '80px 20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const contentWrapper = {
  maxWidth: '1100px',
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
  gap: '60px',
  alignItems: 'start'
};

const infoSide = { textAlign: 'left' };

const eyebrow = {
  color: '#007bff',
  fontWeight: '800',
  fontSize: '12px',
  textTransform: 'uppercase',
  letterSpacing: '1.5px',
  display: 'block',
  marginBottom: '15px'
};

const titleStyle = { fontSize: '42px', fontWeight: '900', marginBottom: '25px', lineHeight: '1.1' };

const descriptionStyle = {
  fontSize: '17px',
  color: '#64748b',
  lineHeight: '1.6',
  marginBottom: '40px'
};

const contactMethod = {
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
  marginBottom: '30px'
};

const iconCircle = {
  width: '50px',
  height: '50px',
  backgroundColor: '#fff',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '20px',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
};

const methodLabel = { fontSize: '13px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase' };

const emailLink = { fontSize: '18px', color: '#007bff', fontWeight: '700', textDecoration: 'none' };

const addressText = { fontSize: '16px', color: '#334155', fontWeight: '500' };

const formSide = {
  backgroundColor: '#fff',
  padding: '40px',
  borderRadius: '16px',
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  border: '1px solid #e2e8f0'
};

const formStyle = { display: 'flex', flexDirection: 'column', gap: '20px' };

const inputGroup = { display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'left' };

const labelStyle = { fontSize: '14px', fontWeight: '700', color: '#334155' };

const inputStyle = {
  padding: '12px 16px',
  borderRadius: '8px',
  border: '1px solid #cbd5e1',
  fontSize: '15px',
  outline: 'none',
  fontFamily: 'inherit',
  transition: 'border-color 0.2s',
  ':focus': { borderColor: '#007bff' }
};

const submitButtonStyle = {
  backgroundColor: '#007bff',
  color: '#fff',
  padding: '16px',
  borderRadius: '8px',
  border: 'none',
  fontWeight: '700',
  fontSize: '16px',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  marginTop: '10px'
};

const disclaimer = { fontSize: '12px', color: '#94a3b8', marginTop: '10px', fontStyle: 'italic', textAlign: 'center' };

export default ContactUs;
